import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpStatusCode from "axios";
import { mainAxios } from "../../app/api";
import service from "../../config.json";
import { errorToast } from "../../helpers/toaster";
const { Authorization } = JSON.parse(sessionStorage.getItem("userData")) || {};

const {
  fetchAirports,
  flightSearch,
  flightFareRule,
  flightFareQuote,
  flightBook,
  flightSSR,
} = service;

const initialState = {
  flightSearched: [],
  loading: true,
  flightListLoader: true,
  adultsCount: 1,
  childsCount: 0,
  infantsCount: 0,
  airList: [],
  fareRule: [],
  fareQuote: [],
  BookingStatus: {},
  sessionExpired: false,
};

export const fetchAirportsAsync = createAsyncThunk(
  "flight/fetchAirportsAsync",
  async (name) => {
    const { Authorization } =
      JSON.parse(sessionStorage.getItem("userData")) || {};
    try {
      const res = await mainAxios.get(fetchAirports.concat(`/${name}`), {
        headers: { Authorization },
      });
      return res.data;
    } catch (err) {}
  }
);

export const flightSearchAsync = createAsyncThunk(
  "flight/flightSearchAsync",
  async (val) => {
    if (val.state.ReturnDate === "") {
      delete val.state["ReturnDate"];
    }
    const {
      adultsCount,
      childsCount,
      infantsCount,
      travelClass,
      tripType,
      directFlight,
      Authorization,
    } = val;
    const { pickUp, dropOff, DepartureDate, ReturnDate } = val.state || {};

    let Segment = [
      {
        Origin: pickUp.airportcode,
        Destination: dropOff.airportcode,
        PreferredDepartureTime: new Date(DepartureDate)
          .toISOString()
          .split(".")[0],
        PreferredArrivalTime: new Date(DepartureDate)
          .toISOString()
          .split(".")[0],
      },
    ];
    if (tripType === "2") {
      Segment.push({
        Origin: dropOff.airportcode,
        Destination: pickUp.airportcode,
        PreferredDepartureTime: new Date(ReturnDate)
          .toISOString()
          .split(".")[0],
        PreferredArrivalTime: new Date(ReturnDate).toISOString().split(".")[0],
      });
    }

    try {
      const res = await mainAxios.post(
        flightSearch,
        {
          EndUserBrowserAgent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.128 Safari/537.36",
          JourneyType: parseInt(tripType),
          AdultCount: adultsCount,
          ChildCount: childsCount,
          InfantCount: infantsCount,
          FlightCabinClass: parseInt(travelClass),
          DirectFlight: directFlight,
          Segment: Segment,
        },
        {
          headers: { Authorization },
        }
      );
      return res.data;
    } catch (err) {
      return err.data;
    }
  }
);

// flightFareRuleAsync=
export const flightFareRuleAsync = createAsyncThunk(
  "flight/flightFareRuleAsync",
  async (state) => {
    try {
      const { TokenId, TrackingId, ResultId, Authorization } = state;
      let EndUserBrowserAgent =
        "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.128 Safari/537.36";
      const res = await mainAxios.post(
        flightFareRule,
        {
          TokenId,
          TrackingId,
          ResultId,
          EndUserBrowserAgent,
        },
        {
          headers: { Authorization },
        }
      );
      return res.data;
    } catch (err) {}
  }
);

export const flightFareQuoteAsync = createAsyncThunk(
  "flight/flightFareQuoteAsync",
  async (state) => {
    try {
      const { TrackingId, ResultId, Authorization } = state;
      let EndUserBrowserAgent =
        "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.128 Safari/537.36";
      const res = await mainAxios.post(
        flightFareQuote,
        {
          TrackingId,
          ResultId,
          EndUserBrowserAgent,
        },
        {
          headers: { Authorization },
        }
      );
      return res.data;
    } catch (err) {
      return err.resonse;
    }
  }
);

  // flightBookAsync
  export const flightBookAsync = createAsyncThunk(
    "flight/flightBookAsync",
    async (val) => {
      let EndUserBrowserAgent =
        "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.128 Safari/537.36";
      const {
        TrackingId,
        ResultId,
        TokenId,
        Authorization,
        NonRefundable,
        AirlineRemark,
        TicketAdvisory,
        ValidatingAirline,
        Airline,
        JourneyType,
        IsLcc,
        ResponseTime,
        Origin,
        Destination,
        TravelDate,
        LastTicketDate,
        CreatedOn,
        SearchType,
        AgentRefNo,
        EarnedLoyaltyPoints,
        ValidatingAirlineCode,
        StaffRemarks,
        PointOfSale,
        IsDomestic,
        RequestOrigin,
        UserData,
        Passenger,
        FareRules,
        Segments,
        fare,
        fareRulesDetail,
      } = val;
      try {
        let params = {
          Segments,
          Passenger,
          IsHoldEligibleForLcc: true,
          ValidatingAirlineCode, //
          LastTicketDate, //
          SearchType: parseInt(SearchType), //
          NonRefundable,
          AirlineRemark,
          TicketAdvisory,
          ValidatingAirline,
          Airline,
          JourneyType: parseInt(JourneyType),
          IsLcc,
          // ProviderRemarks,
          ResponseTime,
          Origin, //from quote
          Destination, //from quote
          FareRules,
          TravelDate,
          CreatedOn,
          StaffRemarks,
          PointOfSale,
          AgentRefNo,
          IsDomestic, //
          EarnedLoyaltyPoints,
          RequestOrigin, //
          EndUserBrowserAgent,
          UserData,
        };

        const res = await mainAxios.post(
          flightBook,
          {
            TokenId,
            ResultId,
            TrackingId,
            Itinerary: params,
            Fare: fare,
            FareRules: fareRulesDetail,
          },
          {
            headers: {
              Authorization,
            },
          }
        );
        return res.data;
      } catch (err) {
        return err.response;
      }
    }
  );

  export const flightSSRAsync = createAsyncThunk(
    "flight/flightSSRAsync",
    async (state) => {
      try {
        const { TrackingId, ResultId, Authorization } = state;
        let EndUserBrowserAgent =
          "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.128 Safari/537.36";
        const res = await mainAxios.post(
          flightSSR,
          {
            TrackingId,
            ResultId,
            EndUserBrowserAgent,
          },
          {
            headers: { Authorization },
          }
        );
        return res.data;
      } catch (err) {}
    }
  );

  export const flightSlice = createSlice({
    name: "flight",
    initialState,
    reducers: {
      adultInc: (state) => {
        state.adultsCount = state.adultsCount + 1;
      },
      childInc: (state) => {
        state.childsCount = state.childsCount + 1;
      },
      infantInc: (state) => {
        state.infantsCount = state.infantsCount + 1;
      },
      adultDec: (state) => {
        if (state.infantsCount === state.adultsCount) {
          state.infantsCount = state.adultsCount - 1;
        }
        state.adultsCount = state.adultsCount - 1;
      },
      childDec: (state) => {
        state.childsCount = state.childsCount - 1;
      },
      infantDec: (state) => {
        state.infantsCount = state.infantsCount - 1;
      },
      setFlightCounts: (state, { payload }) => {
        const { adultsCount, childsCount, infantsCount } = payload;
        state.adultsCount = parseInt(adultsCount);
        state.childsCount = parseInt(childsCount);
        state.infantsCount = parseInt(infantsCount);
        // state;
      },
      resetAirBooked: (state) => {
        state.BookingStatus = {};
      },
      resetSession: (state) => {
        state.sessionExpired = false;
      },
      ResetLoader: (state) => {
        state.flightListLoader = true;
      },
      ResetFlightSearch: (state) => {
        state.flightSearched = [];
      },
    },
    extraReducers: {
      [fetchAirportsAsync.pending]: (state) => {
        return { ...state };
      },
      [fetchAirportsAsync.fulfilled]: (state, { payload }) => {
        return { ...state, airList: payload.data, loading: false };
      },
      [flightSearchAsync.pending]: (state) => {
        return {
          ...state,
          loading: true,
          flightSearched: [],
          flightListLoader: true,
        };
      },
      [flightSearchAsync.fulfilled]: (state, { payload }) => {
        if (payload?.success) {
          return {
            ...state,
            flightSearched: payload.data,
            loading: false,
            flightListLoader: false,
          };
        } else {
          errorToast("No Results Found!");
          return {
            ...state,
            loading: false,
            flightSearched: [],
            flightListLoader: false,
          };
        }
      },
      [flightSearchAsync.rejected]: (state, payload) => {
        return { ...state, loading: false };
      },
      [flightFareRuleAsync.pending]: (state) => {
        return { ...state, loading: true };
      },
      [flightFareRuleAsync.fulfilled]: (state, { payload }) => {
        return { ...state, loading: false, fareRule: payload.data };
      },
      [flightFareQuoteAsync.pending]: (state) => {
        return { ...state, loading: true };
      },
      [flightFareQuoteAsync.fulfilled]: (state, { payload }) => {
        if (payload?.success) {
          return { ...state, loading: false, fareQuote: payload.data };
        } else {
          return { ...state, loading: false, sessionExpired: true };
        }
      },
      [flightBookAsync.pending]: (state) => {
        return { ...state, loading: true, flightSearched: [] };
      },
      [flightBookAsync.fulfilled]: (state, { payload }) => {
        if (payload?.success) {
          return {
            ...state,
            loading: false,
            BookingStatus: payload.data,
            status: 200,
          };
        } else {
          if (parseInt(payload.status) === 300) {
            return {
              ...state,
              loading: false,
              BookingStatus: false,
              message: payload.data.message,
              status: 300,
            };
          } else {
            return {
              ...state,
              loading: false,
              BookingStatus: false,
              message: payload.data.message,
              status: 400,
            };
          }
        }
      },
      [flightSSRAsync.pending]: (state) => {
        return { ...state, loading: true };
      },
      [flightSSRAsync.fulfilled]: (state, { payload }) => {
        if (payload?.success) {
          return { ...state, SSRData: payload?.data };
        } else {
          errorToast(payload?.message);
          return { ...state, loading: false };
        }
      },
    },
  });

  export const getLoading = (state) => {
    return state.flight.loading;
  };

  export const getCounts = (state) => {
    const { adultsCount, childsCount, infantsCount } = state.flight;
    return { adultsCount, childsCount, infantsCount };
  };

  export const getAirportsList = (state) => {
    return state.flight.airList;
  };

  export const getFlightSearched = (state) => {
    return state.flight.flightSearched;
  };

  export const getFareRules = (state) => {
    return state.flight.fareRule;
    // if (state.flight.fareRule?.FareRules !== undefined) {
    //   return state.flight.fareRule?.FareRules[0][0].FareRuleDetail;
    // }
    // return state.flight.fareRule?.FareRules[0][0].FareRuleDetail;
  };

  export const getFareQuote = (state) => {
    return state.flight.fareQuote;
  };

  export const getAirBookingStatus = (state) => {
    return state.flight.BookingStatus;
  };

  // Action creators are generated for each case reducer function
  export const {
    adultInc,
    childDec,
    childInc,
    adultDec,
    infantDec,
    infantInc,
    setFlightCounts,
    resetAirBooked,
    resetSession,
    ResetLoader,
    ResetFlightSearch,
  } = flightSlice.actions;

  export default flightSlice.reducer;
